export default __webpack_public_path__ + "static/camera_b.3474a687f798f055674c0d85e4afa2c8.png";